import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { find, includes } from 'lodash';
import { Subcategory } from '../Subcategory';
import { Subcategory as SubcategoryType } from '../../../../types';

const SubcategoryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

interface Props {
  selectedSubcategories: SubcategoryType[];
  subcategories: SubcategoryType[];
  categoryKey: string;
  setSubcategory(key: string, subcategory: SubcategoryType): void;
  removeSubcategory(key: string, subcategory: SubcategoryType): void;
}

export class SubcategoryList extends PureComponent<Props> {
  isClickable = subcategory => {
    if (this.props.selectedSubcategories.includes(subcategory)) return true;
    return this.props.selectedSubcategories.length < 3;
  };

  handleOnClick = subcategory => () => {
    if (!this.isClickable(subcategory)) return;
    if (includes(this.props.selectedSubcategories, subcategory))
      this.props.removeSubcategory(this.props.categoryKey, subcategory);
    else this.props.setSubcategory(this.props.categoryKey, subcategory);
  };

  render() {
    const { subcategories } = this.props;
    return (
      <SubcategoryContainer data-qa="subcategory-list">
        {subcategories.map(subcategory => {
          const { name, value } = subcategory;
          return (
            <Subcategory
              key={name + value}
              name={name}
              selected={!!find(this.props.selectedSubcategories, subcategory)}
              onClick={this.handleOnClick(subcategory)}
            />
          );
        })}
      </SubcategoryContainer>
    );
  }
}
